/*!

=========================================================
* BootstrapVue Argon Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import {ServerTable, ClientTable, Event} from 'vue-tables-2-premium';
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';

import VCalendar from "v-calendar";
// import VueFab from 'vue-float-action-button'

import App from './App.vue';

// router setup
import router from './routes/router';
import store from './store/index'

// import './plugins/vue-notification';
// import './plugins/message-box';

import './plugins'

//import router from './routes/starterRouter';
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)

import JsonViewer from 'vue-json-viewer/ssr'
import 'vue-json-viewer/style.css'
Vue.use(VCalendar);
// Vue.use(ClientTable, [options = {}], [useVuex = false], [theme = 'bootstrap3'], [swappables = {}]);
Vue.use(ClientTable);

// Vue.use(VueFab);

// Import JsonViewer as a Vue.js plugin
Vue.use(JsonViewer)
// plugin setup
Vue.use(DashboardPlugin);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
});
